import React, {Component} from 'react';
import {Row, Col, ListGroup} from 'react-bootstrap';
import {Collapse, Label} from 'reactstrap';
import {connect} from 'react-redux'

import { GET_CLIENT_TERMS, GET_DEFAULT_CULTURE } from '../../store/actions/termsPrivacy';

import Aux from "../../hoc/_Aux";
import Card from "../../App/components/MainCard";
import withRouter from '../../App/components/withRouter';
import { cacheService, getLang, getLanguageFromLocation, portalLogoUrl } from '../../helper/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";
import { PAGE_CODE } from '../../helper/constant';
import Select from 'react-select';
import { getJsonLanguage } from '../../helper/i18next-utils';
import { PORTAL_INSTANCE } from '../..';
import FAQ from '../../models/FAQ';
import { FAQ_TYPES } from '../../constants/commons';

const mapStateToProps = (state, ownProps) => {
    return {
        termsPrivacy:state.termsPrivacy.termsPrivacyDetail
     }
     
  }
  
  const mapDispatchToProps = (dispatch)=>{
    return {
        GET_CLIENT_TERMS :(payload) => dispatch(GET_CLIENT_TERMS(payload)),
        GET_DEFAULT_CULTURE: (payload) => dispatch(GET_DEFAULT_CULTURE(payload)),
        }
    }
  
const pageCode = PAGE_CODE.CP_FAQS;

class FAQs extends Component {
    constructor(props) {
        super(props);
        let { pId } = PORTAL_INSTANCE
        this.state = {
            portalId: pId,
            openItems: {},
            culture: null,
            cultureList: [],
            otherFAQs: [],
            otherFAQsByCulture: []
        }
    }

    async componentDidMount(){
        // const payload = {
        //     portalId: PORTAL_INSTANCE.pId,
        //     clientId: PORTAL_INSTANCE.cId,
        // }
        // this.props.GET_CLIENT_TERMS(payload)

        // let otherFAQs = await FAQ.getFAQs();
        let otherFAQs = await FAQ.getPortalFAQs(this.state.portalId)
        otherFAQs = (otherFAQs || [])
        otherFAQs = otherFAQs.filter(r => r.type === FAQ_TYPES.OTHER);

        let localLang = 'en-US'
        const selectedLang = cacheService.getCache('selectedLang');
        const cultureList = cacheService.getCache('cultureList') || [];
        const isCultureMissingLangId = cultureList?.length ? cultureList.some(culture => !culture?.langId) : false;
        if (!selectedLang || !cultureList || isCultureMissingLangId) {
            localLang = getLang(this.state.portalId)

            const cultureInfo = await this.props.GET_DEFAULT_CULTURE({ portalId: this.state.portalId });
            if (cultureInfo && cultureInfo.shortCut) {
                localLang = cultureInfo.shortCut
                this.setState({ defaultCulture: cultureInfo });
            }
            const {code, cultureList } = await getLanguageFromLocation()
            if (code && cultureList?.length) {
                localLang = code
                const cultureListOptions = cultureList.filter(culture => culture?.cultureInfo?.shortCut).map(culture => ({ value: culture?.cultureInfo?.shortCut, label: culture?.cultureInfo?.name, langId: culture?.cultureId }))
                
                const foundCulture = cultureListOptions.find(culture => culture.value === code)
                if (foundCulture) {
                    this.setState({ culture: { value: foundCulture.value, label: foundCulture.label, langId: foundCulture.langId }, cultureList: cultureListOptions });
                    cacheService.setCache('cultureList', cultureListOptions);
                }
            }
            cacheService.setCache('selectedLang', localLang);
            
        } else {
            localLang = selectedLang
            this.setState({ cultureList: cultureList });
            const foundCulture = cultureList.find(culture => culture.value === localLang)
            if (foundCulture) {
                this.setState({ culture: { value: foundCulture.value, label: foundCulture.label, langId: foundCulture.langId }});
            }
        }

        this.setState({ 
            otherFAQs: otherFAQs
        }, () => {
            if (localLang) {
                getJsonLanguage(localLang, PORTAL_INSTANCE.pId)
            }
            this.findOtherFAQsByCulture()
        })

    }

    findOtherFAQsByCulture = () => {
        const { otherFAQs } = this.state;
        const otherFAQsByCulture = [];
        const langId = this.state.culture?.langId;
        for (const item of otherFAQs) {
            const translation =  item.translations?.length ? item.translations.find(r => r.langId === langId) : null;
            if (translation) {
                otherFAQsByCulture.push({
                    title: translation.title,
                    description: translation.description
                });
            } else {
                otherFAQsByCulture.push({
                    title: item.title,
                    description: item.description
                });
            }
        }
        this.setState({ otherFAQsByCulture: otherFAQsByCulture })
    }

    toggleItem = (index) => {
        this.setState(prevState => ({
            openItems: {
                ...prevState.openItems,
                [index]: !prevState.openItems[index]
            }
        }))
    }

    onChangeLanguage = (option) => {
        cacheService.setCache('selectedLang', option.value);
        this.setState({ culture: option }, () => {
            getJsonLanguage(option.value, PORTAL_INSTANCE.pId)
            this.findOtherFAQsByCulture()
        })
    }

    render() {
        const {termsPrivacy, t} = this.props
        const {openItems} = this.state

        const faqDataNumber = 6;

        return (
            <Aux>
                <Row>
                    <Col>
                        <div style={{ 
                            textAlign: 'center', 
                            marginBottom: '2rem',
                            padding: '2rem 0'
                        }}>
                            <img 
                                src={portalLogoUrl()} 
                                alt="Logo" 
                                style={{ 
                                    maxWidth: '150px', 
                                    height: 'auto',
                                    marginBottom: '1rem'
                                }} 
                            />
                            <h1 style={{ 
                                fontSize: '2.5rem', 
                                fontWeight: '600',
                                color: '#161616',
                                marginTop: '1rem'
                            }}>
                                {t(`${pageCode}.LabelFrequentlyAskedQuestions`)}
                            </h1>
                        </div>
                        <Card>
                            <div className="faq-list" style={{ marginTop: '1rem' }}>
                                <ListGroup>
                                    {this.state.otherFAQsByCulture.map((item, index) => (
                                        <ListGroup.Item 
                                            key={index}
                                            onClick={() => this.toggleItem(index)} 
                                            style={{ 
                                                cursor: 'pointer',
                                                padding: '1rem',
                                                borderRadius: '0.625rem',
                                                border: '1px solid #D7D7D7',
                                                marginTop: '0.188rem',
                                                marginBottom: '0.625rem',
                                                borderTopWidth: '0.063rem'
                                            }}
                                        >
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-between align-items-center">
                                                    <div className="ms-2 me-auto">
                                                        <div className="faq-list_title" style={{
                                                            fontSize: '1rem',
                                                            lineHeight: '1.5rem',
                                                            color: '#161616',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {`${index + 1}. ${item.title}`}
                                                        </div>
                                                    </div>
                                                    <div 
                                                        className={`li-arrow ${openItems[index] ? "open" : ""}`}
                                                        style={{
                                                            transition: 'transform 0.3s ease, color 0.3s ease'
                                                        }}
                                                    >
                                                        <i 
                                                            className="fa fa-chevron-down" 
                                                            aria-hidden="true"
                                                            style={{
                                                                transform: openItems[index] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                color: openItems[index] ? '#065737' : '#161616',
                                                                transition: 'transform 0.3s ease, color 0.3s ease'
                                                            }}
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <Collapse isOpen={openItems[index]}>
                                                        <div style={{ 
                                                            borderTop: '0.125rem solid #e3e3e3', 
                                                            margin: '0.625rem',
                                                            paddingTop: '1rem'
                                                        }}>
                                                            <div style={{
                                                                marginBottom: '0',
                                                                fontWeight: '400',
                                                                fontSize: '1rem',
                                                                lineHeight: '1.5rem',
                                                                color: '#161616'
                                                            }}>
                                                                <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            </div>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </div>
                            {termsPrivacy && termsPrivacy.faqs ? (
                                <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid #e3e3e3' }}>
                                    <div dangerouslySetInnerHTML={{ __html: termsPrivacy.faqs }} />
                                </div>
                            ) : null}
                        </Card>
                    </Col>
                </Row>
                <div className="language-select" style={{
                        position: 'absolute',
                        top: '1.25rem',
                        right: '1.25rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.625rem'
                    }}>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faGlobe} className="mr-2" />
                            <Label className="mb-0 mr-2">{t(`${pageCode}.LabelSelectLanguage`)}</Label>
                            <Select
                                className="cp-select-box"
                                name="language" 
                                aria-label={t(`${pageCode}.LabelSelectLanguage`)}
                                placeholder={t(`${pageCode}.LabelSelectLanguage`)}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minWidth: '7.5rem',
                                        borderRadius: '0.25rem',
                                        borderColor: '#ced4da'
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        fontSize: '1rem',
                                        color: '#6c757d'
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected ? '#007bff' : 'white',
                                        color: state.isSelected ? 'white' : 'black',
                                        '&:hover': {
                                            backgroundColor: state.isSelected ? '#0056b3' : '#f8f9fa'
                                        }
                                    })
                                }}
                                options={this.state.cultureList}
                                value={this.state.culture}
                                onChange={this.onChangeLanguage}
                            />
                        </div>
                    </div>
            </Aux>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FAQs)));